<template>
    <div class="tt">
        <slot></slot>
    </div>
</template>
<script>

export default {
    data () {
        return {

        }
    },
    methods : {

    },
    computed: {
        
    }
}
</script>
<style lang="scss" scoped>
.tt {
    font-size: 30px;
    color: #555;
    font-style: normal;
}
</style>